import * as z from "zod/v4";

export const updatePrintNodePassword = {
  name: "updatePrintNodePassword" as const,
  input: z.object({
    email: z.string().email(),
    newPassword: z.string().min(8).max(100),
  }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
